




















import Intense from '@tholman/intense-images';
import cloudinary from '@/services/asset/cloudinary';
import LoaderInline from '@/components/LoaderInline.vue';

function loadImage(src: string): Promise<HTMLImageElement>  {
  const el = new Image();
  return new Promise((resolve, reject) => {
    el.onload = () => resolve(el);
    el.onerror = () => reject(el);
    el.src = src;
  });
}

export default {
  props: {
    src: String,
  },
  data: () => ({
    isLoading: false,
    hasLoaded: false,
  }),
  methods: {
    open() {
      // don't do anything if already loading
      if (this.isLoading || this.hasLoaded) {
        return;
      }

      this.isLoading = true;
      loadImage(cloudinary(this.src))
        .then(() => {

          // create mutation to lookout for fullscreen object inserted by intense plugin
          const mutationObserver = new MutationObserver((mutations: MutationRecord[]) => {
            const addedFullscreen = mutations.find(mutation => (
              !!Array
                .from(mutation.addedNodes)
                .find(node => node.nodeName.toLowerCase() === 'figure')
            ));

            // disconnect once fullscreen object found
            // and show loading as complete
            if (!!addedFullscreen) {
              mutationObserver.disconnect();
              this.isLoading = false;
            }
          });

          // intense is attached on the body so observe here
          mutationObserver.observe(document.body, {
            childList: true,
          });

          // initialise fullscreen on element's data-image attribute
          // and force click to launch fullscreen
          Intense(this.$el);
          this.hasLoaded = true;
          this.$el.click();
        }, () => this.isLoading = false);
    },
  },
  components: {
    LoaderInline,
  },
} as IView;
